import { render } from "./LegoInstallationInstructions.vue?vue&type=template&id=fb12e016&scoped=true"
import script from "./LegoInstallationInstructions.vue?vue&type=script&lang=js"
export * from "./LegoInstallationInstructions.vue?vue&type=script&lang=js"

import "./LegoInstallationInstructions.vue?vue&type=style&index=0&id=fb12e016&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-fb12e016"

export default script